const livestreamCountyIngest = {
  firestorePath: 'livestreamCountyIngest',
  firestoreRefType: 'collection',
  moduleName: 'livestreamCountyIngest',
  statePropName: 'data',
  namespaced: true,
  state: {},
  getters: {
    array: (state) => Object.values(state.data),
    byId: (state) => (id) => state.data[id]
  },
  mutations: {},
  actions: {}
};

export default livestreamCountyIngest;
